import { TableColumnType } from '@ui';
import { EmployeeRole } from '@/api/apis/resources';

export const columns = {
  name: {
    key: 'name',
    label: 'Name',
    isSortable: false,
    minWidthClassName: 'w-[290px]',
  },
  phone: {
    key: 'phone',
    label: 'Phone Number',
    isSortable: false,
    minWidthClassName: 'w-full',
  },
  primaryPhone: {
    key: 'primaryPhone',
    label: 'Primary Phone',
    isSortable: false,
    minWidthClassName: 'min-w-[170px]',
  },
  secondaryPhone: {
    key: 'secondaryPhone',
    label: 'Secondary Phone',
    isSortable: false,
    minWidthClassName: 'min-w-[170px]',
  },
  assign: {
    key: 'assign',
    label: '',
    isSortable: false,
    minWidthClassName: 'min-w-[130px]',
  },
  organ: {
    key: 'organ',
    label: 'Organ',
    isSortable: false,
    minWidthClassName: 'min-w-[100px]',
  },
  baseLocation: {
    key: 'baseLocation',
    label: 'Base Location',
    isSortable: false,
    minWidthClassName: 'min-w-[180px]',
  },
  homeLocation: {
    key: 'homeLocation',
    label: 'Home Location',
    isSortable: false,
    minWidthClassName: 'min-w-[210px]',
  },
  type: {
    key: 'type',
    label: 'Type',
    isSortable: false,
    minWidthClassName: 'min-w-[120px]',
  },
};

export const BASIC_COLUMNS: TableColumnType[] = [
  columns.name,
  columns.primaryPhone,
  columns.secondaryPhone,
  columns.assign,
];

export const ORGAN_LEADERSHIP_COLUMNS: TableColumnType[] = [columns.name, columns.organ, columns.phone, columns.assign];

export const PHONE_SUPPORT_COLUMNS: TableColumnType[] = [
  columns.name,
  columns.organ,
  columns.baseLocation,
  columns.phone,
  columns.assign,
];

export const OPO_CONTACT_COLUMNS: TableColumnType[] = [
  columns.name,
  columns.primaryPhone,
  columns.secondaryPhone,
  columns.type,
  columns.assign,
];

export const getEmployeeColumns = (role: EmployeeRole) => {
  switch (role) {
    case EmployeeRole.OrganLeadership:
      return ORGAN_LEADERSHIP_COLUMNS;
    case EmployeeRole.ClinicalLead:
      return PHONE_SUPPORT_COLUMNS;
    default:
      return BASIC_COLUMNS;
  }
};
